export class ImageBuilder {
    constructor(url, width, height) {
        this.withName = (name) => {
            this.name = name;
            return this;
        };
        this.withDescription = (description) => {
            this.description = description;
            return this;
        };
        this.withContentUrl = (contentUrl) => {
            this.contentUrl = contentUrl;
            return this;
        };
        this.build = () => {
            if (this.name && this.description && this.contentUrl) {
                return {
                    '@context': 'https://schema.org',
                    '@type': 'ImageObject',
                    url: this.url,
                    width: this.width,
                    height: this.height,
                    name: this.name,
                    description: this.description,
                    contentUrl: this.contentUrl,
                };
            }
            if (this.name) {
                if (this.description) {
                    return {
                        '@context': 'https://schema.org',
                        '@type': 'ImageObject',
                        url: this.url,
                        width: this.width,
                        height: this.height,
                        name: this.name,
                        description: this.description,
                    };
                }
                if (this.contentUrl) {
                    return {
                        '@context': 'https://schema.org',
                        '@type': 'ImageObject',
                        url: this.url,
                        width: this.width,
                        height: this.height,
                        name: this.name,
                        contentUrl: this.contentUrl,
                    };
                }
                return {
                    '@context': 'https://schema.org',
                    '@type': 'ImageObject',
                    url: this.url,
                    width: this.width,
                    height: this.height,
                    name: this.name,
                };
            }
            if (this.description) {
                if (this.name) {
                    return {
                        '@context': 'https://schema.org',
                        '@type': 'ImageObject',
                        url: this.url,
                        width: this.width,
                        height: this.height,
                        name: this.name,
                        description: this.description,
                    };
                }
                if (this.contentUrl) {
                    return {
                        '@context': 'https://schema.org',
                        '@type': 'ImageObject',
                        url: this.url,
                        width: this.width,
                        height: this.height,
                        description: this.description,
                        contentUrl: this.contentUrl,
                    };
                }
                return {
                    '@context': 'https://schema.org',
                    '@type': 'ImageObject',
                    url: this.url,
                    width: this.width,
                    height: this.height,
                    description: this.description,
                };
            }
            if (this.contentUrl) {
                if (this.name) {
                    return {
                        '@context': 'https://schema.org',
                        '@type': 'ImageObject',
                        url: this.url,
                        width: this.width,
                        height: this.height,
                        name: this.name,
                        contentUrl: this.contentUrl,
                    };
                }
                if (this.description) {
                    return {
                        '@context': 'https://schema.org',
                        '@type': 'ImageObject',
                        url: this.url,
                        width: this.width,
                        height: this.height,
                        description: this.description,
                        contentUrl: this.contentUrl,
                    };
                }
                return {
                    '@context': 'https://schema.org',
                    '@type': 'ImageObject',
                    url: this.url,
                    width: this.width,
                    height: this.height,
                    contentUrl: this.contentUrl,
                };
            }
            return {
                '@context': 'https://schema.org',
                '@type': 'ImageObject',
                url: this.url,
                width: this.width,
                height: this.height,
            };
        };
        this.url = url;
        this.width = width;
        this.height = height;
    }
}
ImageBuilder.aBuilder = (url, width, height) => {
    return new ImageBuilder(url, width, height);
};
